export const MODULE_NAME = 'api'

export const API_HEADER_STORE_ID = `${MODULE_NAME}/header`

export const API_HEADER_HOST = 'host'
export const API_HEADER_X_FORWARDED_FOR = 'x-forwarded-for'
export const API_HEADER_X_AUTH_TOKEN = 'X-AUTH-TOKEN'
export const API_HEADER_HOST_REQUEST = 'HOST-REQUEST'
export const API_HEADER_HOST_ERCK = 'erck'
export const API_HEADER_LANGUAGE = 'language'
export const API_HEADER_SF_REMEMBER = 'sf-remember'

export const API_ERROR_CODES_WITH_MESSAGE = {
  0: 0,
  400: 400,
  3000: 3000,
  3002: 3002,
  4000: 4000,
  4001: 4001,
  4002: 4002,
  4003: 4003,
  4004: 4004,
  4005: 4005,
  4006: 4006,
  4007: 4007,
  4008: 4008,
  4009: 4009,
  4012: 4012,
  5001: 5001,
  10000: 10000,
  10001: 10001,
  10002: 10002,
  10003: 10003,
}
